import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CompanyForm from './create-company/CompanyForm';
import Congratulations from './create-company/Congratulations';
import DreamWizardChoose from './create-company/DreamWizardChoose';
import NoMatchWizard from './create-company/NoMatchWizard';
import SupportedUseCase from './create-company/SupportedUseCase';
import DreamWizardDemo from './create-company/DreamWizardDemo';
import DreamWizardFunnelBuild from './create-company/DreamWizardFunnelBuild';

import { ReactComponent as BubbleBack } from '../icons/bubble-back.svg';

const CreateCompany = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [stage, setStage] = useState(searchParams.get('stage') || 'form');
  const [selectedUseCase, setSelectedUseCase] = useState('');
  const [funnelId, setFunnelId] = useState(searchParams.get('funnelId'));

  const navigate = useNavigate();

  useEffect(() => {
    const params = searchParams || new URLSearchParams();
    params.set('stage', stage);
    if (funnelId) params.set('funnelId', funnelId);
    setSearchParams(params);
  }, [stage, funnelId, setSearchParams]);

  const handleFormSubmit = () => {
    // setStage('wizard');
    setStage('congratulations');
  };

  const handleSkipWizard = () => {
    setStage('congratulations');
  };

  const getStarted = () => {
    return navigate('/dashboard');
  };

  const handleSelectChoice = (choice) => {
    setSelectedUseCase(choice);
    if (choice === 'none') {
      setStage('none');
    } else if (choice === 'sales_nav') {
      setStage('supported');
    } else {
      setStage('demo');
    }
  };

  const goBackToWizard = () => {
    setStage('wizard');
    setSelectedUseCase('');
  };

  const advanceToFunnelBuild = (funnelId) => {
    setStage('funnel_build');
    setFunnelId(funnelId);
  };

  const shouldHidePanel = ![
    'form',
    'wizard',
    'congratulations',
    'demo',
  ].includes(stage);

  return (
    <div className='full-width-company'>
      <div className='dream-panel-outer'>
        <div className={`dream-panel ${shouldHidePanel ? 'hidden' : ''}`}>
          <BubbleBack />
          <div className='dream-description'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='224'
              height='41'
              viewBox='0 0 224 41'
              fill='none'
            >
              <path
                d='M12.1051 6.98221V34.7556H21.0116C23.471 34.7556 25.6844 34.1232 27.6519 32.8584C29.514 31.6287 30.9721 29.9774 32.0261 27.9045C33.0801 25.8316 33.6071 23.5654 33.6071 21.1061C33.6071 18.5413 33.1065 16.1873 32.1051 14.0441C31.1038 11.901 29.6721 10.197 27.81 8.93215C25.8074 7.63219 23.5061 6.98221 20.9062 6.98221H12.1051ZM3.35679 6.98221L0.827148 1.18511H20.8535C24.3318 1.18511 27.5114 2.08103 30.3924 3.87286C33.1679 5.59442 35.3638 7.9484 36.98 10.9348C38.5961 13.9212 39.4042 17.1711 39.4042 20.6845C39.4042 23.3195 38.886 25.9282 37.8495 28.5105C36.8131 31.0929 35.3814 33.3502 33.5544 35.2826C31.7977 37.1798 29.9181 38.5325 27.9154 39.3406C25.9831 40.1135 23.6818 40.5 21.0116 40.5H6.46615V6.98221H3.35679ZM55.4069 6.92951V19.9993C56.496 19.3669 57.7081 18.9453 59.0432 18.7345C60.027 18.5588 61.2918 18.471 62.8377 18.471H70.3212C72.3941 18.471 74.0103 17.9967 75.1697 17.0481C76.3994 16.0292 77.0142 14.5009 77.0142 12.4631C77.0142 10.5307 76.3643 9.09025 75.0643 8.14163C73.94 7.33355 72.359 6.92951 70.3212 6.92951H55.4069ZM72.2185 34.2813L67.4227 24.2154H62.8377C61.3972 24.2154 60.1324 24.3032 59.0432 24.4789C57.7081 24.7249 56.496 25.1465 55.4069 25.7437V40.5H49.6625V1.18511H70.3212C72.7455 1.18511 74.8886 1.64185 76.7507 2.55534C78.6128 3.46882 80.0533 4.76877 81.0722 6.4552C82.1614 8.24703 82.7059 10.3551 82.7059 12.7793C82.7059 15.7306 81.9154 18.1548 80.3344 20.052C78.7534 21.9493 76.5224 23.2668 73.6414 24.0046L76.698 30.276C77.5764 31.576 78.2615 32.4895 78.7534 33.0165C79.3506 33.684 79.9216 34.132 80.4661 34.3603C81.0107 34.5887 81.7222 34.7029 82.6005 34.7029H83.1802L84.4451 34.6502V40.5C82.4073 40.5 80.8965 40.4297 79.9128 40.2892C78.2615 40.0081 76.8561 39.4635 75.6967 38.6555C74.3265 37.6717 73.1671 36.2137 72.2185 34.2813ZM100.975 24.7424V34.7556H125.217V40.5H95.2303V1.18511H122.898V6.98221H100.975V18.8926C102.064 18.2602 103.276 17.8386 104.611 17.6278C105.595 17.4521 106.86 17.3643 108.406 17.3643H116.996V23.2141H108.406C106.965 23.2141 105.7 23.3019 104.611 23.4776C103.276 23.7235 102.064 24.1451 100.975 24.7424ZM148.018 5.34848L145.857 0.5H152.182L171.101 40.5H164.672L162.089 34.7556H150.126C147.878 34.7556 145.857 34.9664 144.066 35.388C142.485 35.7745 141.167 36.2839 140.113 36.9163C139.164 37.4785 138.532 38.0582 138.216 38.6555L137.214 40.5H130.996L148.018 5.34848ZM152.234 28.9585H159.507L150.917 12.3577L142.221 31.1719C142.994 30.5044 144.171 29.9774 145.752 29.5909C147.544 29.1693 149.705 28.9585 152.234 28.9585ZM213.349 13.4644L199.91 29.5382L186.577 13.4644V40.5H180.938V6.71871L176.353 1.18511H183.784L199.857 20.4736L216.142 1.18511H223.573L218.988 6.71871V40.5H213.349V13.4644Z'
                fill='#FFFEFC'
              />
            </svg>
            <p>Your dream AI sales team.</p>
          </div>
          <div className='url'>usedream.ai</div>
        </div>
      </div>
      <div className='other-panel'>
        {stage === 'form' && <CompanyForm setIsSubmitted={handleFormSubmit} />}
        {stage === 'wizard' && (
          <DreamWizardChoose
            skipWizard={handleSkipWizard}
            selectChoice={handleSelectChoice}
          />
        )}
        {stage === 'none' && (
          <NoMatchWizard
            goBack={goBackToWizard}
            getStarted={handleSkipWizard}
          />
        )}
        {stage === 'supported' && (
          <SupportedUseCase
            useCase={selectedUseCase}
            goBack={goBackToWizard}
            getStarted={handleSkipWizard}
          />
        )}
        {stage === 'demo' && (
          <DreamWizardDemo
            useCase={selectedUseCase}
            goBack={goBackToWizard}
            advanceToFunnelBuild={advanceToFunnelBuild}
          />
        )}
        {stage === 'congratulations' && <Congratulations />}
        {stage === 'funnel_build' && (
          <DreamWizardFunnelBuild funnelId={funnelId} />
        )}
      </div>
    </div>
  );
};

export default CreateCompany;
